export type TSealRequestRow = {
  key: string;
  requestCode: string;
  storeCode: string | null;
  storeName: string | null;
  assetNo: string | null;
  assetName: string | null;
  quantity: number | null;
  requestStatusCode: string | null;
  requestedAt: string | null;
};

export const HEIGHT_TABLE_SCROLL = 640;

export const DISPLAY_EMPTY = '—';

/** Status FE always sends at [E5] OK — do not rely on BE fallback default (api-integration.md §6/§8). */
export const SEND_REQUEST_STATUS_CODE = 'SENT';

export const QUANTITY_MIN = 0;
export const QUANTITY_MAX = 999;

export const MANAGEMENT_SEAL_REQUEST_CONSTANT = {
  TITLE: {
    MANAGEMENT_SEAL_REQUEST: '管理タグ要求',
  },
  TABLE_HEADER: {
    NO: 'No.',
    STORE: '店舗',
    ASSET_NO: '資産番号',
    ASSET_NAME: '資産名称',
    QUANTITY: '要求枚数',
    EDIT: '編集',
  },
  LABEL: {
    TOTAL_RECORDS_PREFIX: '合計件数: ',
    TOTAL_RECORDS_SUFFIX: ' 件',
    UNIT_SHEETS_SUFFIX: ' 枚',
  },
  MESSAGE: {
    NO_DATA: 'タグ要求データがありません。', // MSG-PC008-I01
    QUANTITY_REQUIRED: '要求枚数は0以上の整数で入力してください。', // MSG-PC008-V01
    SEND_SUCCESS: 'タグ発行依頼を送信しました。', // MSG-PC008-S01
    LOAD_ERROR: 'データの取得に失敗しました。再度お試しください。', // MSG-PC008-E01
    SEND_ERROR: '送信に失敗しました。再度お試しください。', // MSG-PC008-E02
    SYSTEM_ERROR:
      'システムエラーが発生しました。管理者にお問い合わせください。', // MSG-PC008-E03
  },
  // VAMS_PC_008_01 — 数量編集ダイアログ (Dialog D)
  DIALOG_QUANTITY_EDIT: {
    TITLE: '数量編集ダイアログ',
    STORE: '店舗',
    ASSET_NO: '資産番号',
    ASSET_NAME: '資産名称',
    CURRENT_QUANTITY: '現在の要求枚数',
    NEW_QUANTITY: '新しい要求枚数',
    NEW_QUANTITY_NOTE: '0 を指定した場合、発行されません',
    BTN_CANCEL: 'キャンセル',
    BTN_SEND: '送信',
  },
  // VAMS_PC_008_02 — 送信確認ダイアログ (Dialog E)
  DIALOG_SEND_CONFIRM: {
    TITLE: '送信確認ダイアログ',
    MESSAGE: '以下の内容でタグ発行依頼を印刷会社へ送信してもよろしいですか？',
    COLUMN_LABEL: '項目名',
    COLUMN_VALUE: '値',
    ROW_STORE: '店舗',
    ROW_ASSET_NO: '資産番号',
    ROW_ASSET_NAME: '資産名称',
    ROW_QUANTITY: '送信枚数',
    BTN_CANCEL: 'キャンセル',
    BTN_OK: 'OK',
  },
};
